<template>
  <div class="ds-sheet">
    <header class="ds-letterhead">
      <div class="ds-brand">
        <img v-if="logoUrl" :src="logoUrl" class="ds-logo" alt="">
        <div v-else class="ds-brand-name">{{ letterhead.name }}</div>
      </div>
      <div class="ds-company">
        <div class="ds-company-name">{{ letterhead.name }}</div>
        <div v-if="letterhead.url">{{ letterhead.url }}</div>
        <div v-if="letterhead.tel">Tel. {{ letterhead.tel }}</div>
      </div>
    </header>
    <section class="ds-intro">
      <div class="ds-eyebrow">Verkäufe</div>
      <div class="ds-title">Zusammenfassung</div>
    </section>
    <table class="ds-fields">
      <tbody>
        <tr>
          <th scope="row">Zeitraum</th>
          <td>{{ periodText }}</td>
        </tr>
        <tr>
          <th scope="row">Filter</th>
          <td>{{ filterText || 'keine' }}</td>
        </tr>
        <tr>
          <th scope="row">Erstellt am</th>
          <td>{{ createdAt }}</td>
        </tr>
      </tbody>
    </table>
    <section class="ds-kpis">
      <div class="ds-kpi ds-kpi-main">
        <span>Summe</span>
        <strong>{{ euro(sum) }}</strong>
      </div>
    </section>
    <footer class="ds-footer">
      <span>Gute Fahrt wünscht</span>
      <img :src="simaLogoUrl" class="ds-sima-logo" alt="SIMA">
      <span>www.simasoftware.de</span>
    </footer>
  </div>
</template>

<script>
// Druckblatt „Zusammenfassung“ der Verkäufe (Kundenwunsch 13.10.2026): Inhalt wie die frühere Word-Vorlage
// TicketSaleSummaryTemplate.docx – Zeitraum, Filter (gesetzte Filter und Suche), Summe und Erstelldatum –, Kopf und Fuß
// sowie die Erzeugung im Browser wie die Fahrerabrechnung (Briefkopf mit Kundenlogo und Kundendaten, Fuß mit Gruß und
// SIMA-Logo). Nur Markup mit den Klassen .ds-* (Aussehen und Druck in src/utils/printSheet.js); TicketSale rendert es
// unsichtbar und druckt sein HTML. Props: sum (Summe der Preise nach Filter und Suche, netto), letterhead
// { name, url, tel }, logoUrl, simaLogoUrl, periodText, filterText, createdAt.
const euroFormat = new Intl.NumberFormat("de-DE", { style: "currency", currency: "EUR" });

export default {
  name: "SaleSummarySheet",
  props: {
    sum: { type: Number, default: 0 },
    letterhead: { type: Object, required: true },
    logoUrl: { type: String, default: null },
    simaLogoUrl: { type: String, required: true },
    periodText: { type: String, default: "" },
    filterText: { type: String, default: "" },
    createdAt: { type: String, default: "" }
  },
  methods: {
    euro(value) {
      return euroFormat.format(value || 0);
    }
  }
};
</script>
